var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
function SvgPlus(props) {
    return (React.createElement("svg", __assign({ viewBox: '0 0 12 12' }, props),
        React.createElement("path", { d: 'M11.05 5.321a.75.75 0 01.102 1.494l-.102.006h-10a.75.75 0 01-.102-1.493l.102-.007h10z' }),
        React.createElement("path", { d: 'M6.03.25a.75.75 0 01.743.648L6.78 1v10a.75.75 0 01-1.493.102L5.28 11V1a.75.75 0 01.75-.75z' })));
}
export default SvgPlus;
//# sourceMappingURL=Plus.js.map